import axios from 'axios';

import { uuid } from 'uuidv4';

// const api = axios.create({
//   baseURL: process.env.REACT_APP_URL_ADSERVER,
// });
let api = undefined;
class ApiService {
  requestId;

  initApi = (urlAdserver) => {
    if (urlAdserver) {
      api = axios.create({
        baseURL: urlAdserver,
      });
    } else {
      api = axios.create({
        baseURL: process.env.REACT_APP_URL_ADSERVER,
      });
    }
  };

  getHeaders = () => {
    return { headers: { requestId: this.requestId } };
  };

  setRequestId = (requestId) => {
    this.requestId = requestId;
  };

  init = async (zoneUuid, userId, context, urlAdserver) => {
    this.initApi(urlAdserver);
    const response = await api.post(`campaign/v2/${zoneUuid}`, {
      userId,
      context,
    });
    const {
      data: { requestId },
    } = response;
    this.requestId = requestId || uuid();
    return response;
  };

  initByCode = async (code, urlAdserver) => {
    this.initApi(urlAdserver);
    const response = await api.get(`campaign/init/v2/${code}`);
    const {
      data: { requestId },
    } = response;
    this.requestId = requestId || uuid();
    return response;
  };

  impressionEvent = (campaignUuid, userId, body) => {
    return api.post(
      `tracker?requestId=${this.requestId}&c=${campaignUuid}&u=${userId}&e=impression`,
      body,
      this.getHeaders()
    );
  };

  interactionEvent = (campaignUuid, userId, mediaUuid) => {
    return api.post(
      `tracker?requestId=${this.requestId}&c=${campaignUuid}&u=${userId}&e=interaction${mediaUuid ? `&m=${mediaUuid}` : ''}`,
      {},
      this.getHeaders()
    );
  };

  vastEvent = (campaignUuid, userId, mediaUuid, event) => {
    return api.post(
      `tracker?requestId=${this.requestId}&c=${campaignUuid}&u=${userId}&e=${event}${mediaUuid ? `&m=${mediaUuid}` : ''}`,
      {},
      this.getHeaders()
    );
  };

  completeEvent = (campaignUuid, userId, mediaUuid) => {
    return api.post(
      `tracker?requestId=${this.requestId}&c=${campaignUuid}&u=${userId}&e=complete${mediaUuid ? `&m=${mediaUuid}` : ''}`,
      {},
      this.getHeaders()
    );
  };

  acceptConfirmationTermEvent = (campaignUuid, userId, mediaUuid) => {
    return api.post(
      `tracker?requestId=${this.requestId}&c=${campaignUuid}&u=${userId}&e=accept-confirmation-term${mediaUuid ? `&m=${mediaUuid}` : ''}`,
      {},
      this.getHeaders()
    );
  };

  errorEvent = (campaignUuid, userId, constError = 'error-sdk', error) => {
    return api.post(
      `tracker/general-error?requestId=${this.requestId}&c=${campaignUuid}&u=${userId}&e=${constError}`,
      { error },
      this.getHeaders()
    );
  };

  conversion = (campaignUuid, userId) => {
    return api.post(
      `tracker/conversion?requestId=${this.requestId}&c=${campaignUuid}&u=${userId}`,
      {},
      this.getHeaders()
    );
  };

  trackerQuiz = (arrayQuiz, campaignUuid, userId, mediaUuid) => {
    arrayQuiz.forEach((quiz) => {
      quiz.requestId = this.requestId;
    });
    return api.post(
      `tracker/quiz?requestId=${this.requestId}&c=${campaignUuid}&u=${userId}${mediaUuid ? `&m=${mediaUuid}` : ''}`,
      arrayQuiz,
      this.getHeaders()
    );
  };
}

export default ApiService;
